exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TicketAddressCard-default-1AXDE .TicketAddressCard-address-3cGut p{margin:0}.TicketAddressCard-address-3cGut ul{margin:0;padding:0;list-style-type:none}.TicketAddressCard-address-3cGut ul>li{display:inline}.TicketAddressCard-address-3cGut ul>li:not(:last-child):after{content:\", \"}.TicketAddressCard-noTicketInfo-1xHif{text-align:center}", ""]);

// exports
exports.locals = {
	"default": "TicketAddressCard-default-1AXDE",
	"address": "TicketAddressCard-address-3cGut",
	"noTicketInfo": "TicketAddressCard-noTicketInfo-1xHif"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/TicketAddressCard.less
// module id = 1772
// module chunks = 0